package navigation.home.edititinerary

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import cafe.adriel.voyager.core.screen.Screen
import com.essntl.uikit.components.spinner.EsSpinner

class LoaderScreenNav : Screen {

    @Composable
    override fun Content() {
        Box(
            contentAlignment = Alignment.Center,
            modifier = Modifier.fillMaxSize(),
        ) {
            EsSpinner(modifier = Modifier.align(Alignment.Center))
        }
    }
}